import React from 'react'
//import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client'
import './assets/index.css'
import App from './App'
import * as serviceWorker from './services/serviceWorker'
import { ErrorProvider } from 'src/context/useAddErrorContext'
const root = createRoot(document.getElementById('root'))

root.render(
  // <React.StrictMode>
  <ErrorProvider>
    <App />
  </ErrorProvider>
  // </React.StrictMode>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
